module.exports = __webpack_public_path__ + "static/media/3.c1cdb01d.jpg";